export const Endpoints = {
  api: "https://api.train4ten.net/api",
 // list_languages: "/languages",
  list_languages: (tenantID, projectID) =>
    `/languages?tenant_id=${tenantID}&project_id=${projectID}`,

  register: "/register_to_go",
  list_courses: "/education_courses_available_to_go/",
  enrollment: "/education_course_enrollments",
  list_material: "/education_sections_with_materials_by_course_id/",
  // quiz: "/education_section_materials_get_test/",
  quiz: "/v1/modules/questions",

  check_answers: "/education_answer_check_single",
  // submit_answers: "/education_test_result_ready_to_go",
  submit_answers: "/v1/modules/tests/results",

  vid: "/education_section_materials_get_video_stream/",
  sub: "/education_section_materials_get_subtitle_stream/",
  pdf: "/education_section_materials_get_file_stream/",
  material_progress: "/education_material_progress",
  certificate: "/v1/certificate",
  test_stream_video:
    "/education_section_materials_get_video_stream/f817befb-32bc-4e92-975b-9416f14a278e",
  education_section_materials_get_video_pseudo_stream:
    "/education_section_materials_get_video_pseudo_stream/",
 // Function to get the project list with dynamic language_id and tenant_id
 get_project_list: (languageId, tenantId) =>
  `/v1/projects?language_id=${languageId}&tenant_id=${tenantId}`,
 // Get the training types as per project ID
 get_trainings: (projectId) => `/v1/trainings?project_id=${projectId}`,
 // get modules/materials
 get_materials: (trainingID)=>`/v1/modules?training_id=${trainingID}`,
 reorder_materials:"/v1/modules/reorder"
};
